import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import { getMethod, postMethod } from "../service";
import {
  decodeData,
  errorToaster,
  formatDate,
  successToaster,
} from "../utils/Helper";
import { useNavigate } from "react-router-dom";
import { DEPOSITS_API, DEPOSITS_CONFIRM_API } from "../service/constant";
import Pagination from "../utils/Pagination";
import Input from "../utils/Input";
import DateRangeFormat from "../utils/DateRangeFormat";
import SubmitBtn from "../utils/SubmitBtn";
import { useSelector } from "react-redux";

const Deposits = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { refresh } = useSelector((state) => state.refresh);

  const navigate = useNavigate();

  const fetchDeposits = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await getMethod(
          `${DEPOSITS_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}&search=${searchId}`,
          token.token
        );
        if (res?.isSuccess) {
          setDeposits(res.data);
          setFrom((res.meta?.current_page - 1) * 50);
          setTotalPage(res.meta?.last_page);
        } else {
          errorToaster("Failed to fetch deposits");
        }
      } catch (error) {
        console.error("Error fetching deposits:", error);
        errorToaster("An error occurred while fetching deposits");
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  const handleConfirm = async (cashin_id) => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await postMethod(
          `${DEPOSITS_CONFIRM_API}`,
          { state: "approve", cashin_id: cashin_id },
          token.token
        );
        if (res?.isSuccess) {
          successToaster("Deposit approved successfully.");
          fetchDeposits();
        } else {
          errorToaster(res?.message || "Failed to approve deposit");
        }
      } catch (error) {
        console.error("Error confirming deposit:", error);
        errorToaster("An error occurred while approving deposit");
      }
      setIsLoading(false);
    }
  };

  const handleReject = async (cashin_id) => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await postMethod(
          `${DEPOSITS_CONFIRM_API}`,
          { state: "reject", cashin_id: cashin_id },
          token.token
        );
        if (res?.isSuccess) {
          successToaster("Deposit rejected successfully.");
          fetchDeposits();
        } else {
          errorToaster(res?.message || "Failed to reject deposit");
        }
      } catch (error) {
        console.error("Error rejecting deposit:", error);
        errorToaster("An error occurred while rejecting deposit");
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDeposits();
  }, [refs, page, refresh]);

  return (
    <Template title={"Deposits"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>

          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>User Name</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Transaction Number</th>
              <th>Status</th>
              <th>Bank Type</th>
              <th>Bank Acc Name </th>
              <th>Bank Acc No</th>
              <th>Date & Time</th>
            </TableHeader>
            <TableBody>
              {deposits.length > 0 &&
                deposits.map((deposit, i) => (
                  <tr key={deposit._id} style={{ verticalAlign: "middle" }}>
                    <td>{i + 1}</td>
                    <td>{deposit?.userId?.name}</td>
                    <td>{deposit?.userId?.phone}</td>
                    <td className="text-end">
                      {deposit.amount.toLocaleString("en-us")}
                    </td>

                    <td>{deposit?.transactionNumber}</td>
                    <td>
                      {deposit?.state === "pending" && (
                        <>
                          <button
                            className="btn btn-success py-1"
                            onClick={() => handleConfirm(deposit._id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-danger  ms-2 py-1"
                            onClick={() => handleReject(deposit._id)}
                          >
                            Reject
                          </button>
                        </>
                      )}

                      {deposit?.state === "approve" && (
                        <span className="badge bg-success py-1">Approved</span>
                      )}

                      {deposit?.state === "reject" && (
                        <span className="badge bg-danger py-1">Rejected</span>
                      )}
                    </td>
                    <td>{deposit?.payment_provider_id?.bank_type}</td>
                    <td>{deposit?.payment_provider_id?.bank_acc_name}</td>
                    <td>{deposit?.payment_provider_id?.bank_acc_number}</td>
                    <td>{formatDate(deposit?.createdAt)}</td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default Deposits;
